"use strict";

exports.__esModule = true;
exports.default = void 0;
var _actionTypes = require("./actionTypes");
const reducer = (state = {}, action) => {
  switch (action.type) {
    case _actionTypes.INIT_SSOAUTH:
      return state;
    case _actionTypes.SET_QUERY_PARAMETERS:
      return {
        ...state,
        queryParameters: action.payload
      };
    default:
      return state;
  }
};
var _default = exports.default = reducer;
module.exports = exports.default;